export default function Logo(props) {
	return (
		<svg
			width="40"
			height="36"
			viewBox="0 0 40 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.2093 0.0544048C35.5915 3.35934 39.9492 9.99647 39.9492 17.6494C39.9492 25.3023 35.5915 31.9419 29.2093 35.2443C28.9603 35.3731 28.6515 35.2691 28.532 35.0164C27.9069 33.7009 27.3367 32.1128 26.8138 30.2473C26.388 28.7311 26.0418 27.1975 25.7729 25.6516C25.6808 25.1288 24.9437 25.0941 24.8018 25.6045C24.7121 25.934 24.615 26.261 24.5129 26.5881C23.111 31.0624 21.2683 33.2401 18.7707 33.2401C16.2731 33.2401 14.4304 31.0624 13.0284 26.5881C11.2057 20.771 11.2057 14.5278 13.0284 8.71067C14.4304 4.23637 16.2731 2.05867 18.7707 2.05867C21.2683 2.05867 23.111 4.23637 24.5129 8.71067C24.615 9.03769 24.7121 9.36472 24.8018 9.69422C24.9437 10.2046 25.6833 10.1699 25.7729 9.64715C26.0418 8.10121 26.388 6.56766 26.8138 5.05145C27.3367 3.18592 27.9069 1.59787 28.532 0.282332C28.6515 0.0296302 28.9603 -0.0744234 29.2093 0.0544048ZM9.4551 12.0775C10.7948 15.6699 10.7948 19.6313 9.4551 23.2237C8.43663 25.9613 7.09445 27.2941 5.28413 27.2941C3.47381 27.2941 2.13412 25.9613 1.11317 23.2237C-0.226524 19.6313 -0.226524 15.6699 1.11317 12.0775C2.13163 9.33995 3.47381 8.00707 5.28413 8.00707C7.09445 8.00707 8.43414 9.33995 9.4551 12.0775Z"
				fill={props.fill || `var(--wp--preset--color--ash)`}
			/>
		</svg>
	);
}
